import { render, staticRenderFns } from "./FacultyCard.vue?vue&type=template&id=59c586c2&scoped=true&"
import script from "./FacultyCard.vue?vue&type=script&lang=js&"
export * from "./FacultyCard.vue?vue&type=script&lang=js&"
import style0 from "./FacultyCard.vue?vue&type=style&index=0&id=59c586c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c586c2",
  null
  
)

component.options.__file = "FacultyCard.vue"
export default component.exports